import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import Wordmark from './Wordmark';
import { footerLinks, routes } from '../data';

const copyrightYear = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-top">
        <div className="footer-brand">
          <Wordmark inverted className="footer-wordmark" />
          <SocialLinks />
        </div>
        <nav aria-label="Footer navigation">
          {footerLinks.map((link) => (
            <Link key={link.href} to={link.href}>
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="container footer-bottom">
        <p>© {copyrightYear} Rime, LLC. All rights reserved.</p>
        <p className="footer-legal">
          <Link to={routes.privacy}>Privacy Policy</Link>
          <Link to={routes.terms}>Terms of Service</Link>
        </p>
      </div>
    </footer>
  );
}
